(function () {
  const app = document.getElementById('tt-app');
  if (!app) return;

  const PACK_PRICE = 399, GLASS_PRICE = 119, FREE_SHIP = 299;
  let packs = 1, extras = 0;

  /* --- Sidbyte --- */
  function showPage(name, scrollTo) {
    app.querySelectorAll('.tt-page').forEach(p =>
      p.classList.toggle('is-active', p.dataset.page === name));
    app.querySelectorAll('.tt-nav a').forEach(a =>
      a.classList.toggle('is-active', a.dataset.nav === name && !a.dataset.scroll));
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0 });
    }
  }

  app.addEventListener('click', function (e) {
    const nav = e.target.closest('[data-nav]');
    if (nav) {
      e.preventDefault();
      if (nav.dataset.variant === 'four') { packs = 1; extras = 0; renderBuy(); }
      if (nav.dataset.variant === 'single') { packs = 0; extras = 1; renderBuy(); }
      showPage(nav.dataset.nav, nav.dataset.scroll);
    }
  });

  /* --- Accordions (FAQ + info) --- */
  app.querySelectorAll('.tt-acc__head').forEach(head => {
    head.addEventListener('click', () => {
      const acc = head.parentElement;
      const open = acc.classList.toggle('is-open');
      acc.querySelector('.tt-acc__ic').textContent = open ? '−' : '+';
    });
  });

  /* --- Steppers + tillägg --- */
  function renderBuy() {
    const packsEl = document.getElementById('tt-packs');
    const extrasEl = document.getElementById('tt-extras');
    const addon = document.getElementById('tt-addon');
    const stepper = document.getElementById('tt-extra-stepper');
    const cta = document.getElementById('tt-addcart');
    const ship = document.getElementById('tt-ship');
    if (!packsEl) return;

    packsEl.textContent = packs;
    extrasEl.textContent = extras;
    addon.classList.toggle('is-on', extras > 0);
    stepper.classList.toggle('tt-stepper--hidden', extras === 0);

    const total = packs * PACK_PRICE + extras * GLASS_PRICE;
    cta.classList.remove('is-cart-added');
    cta.classList.toggle('is-disabled', total <= 0);
    cta.textContent = total > 0 ? 'Lägg i varukorgen · ' + total + ' kr' : 'Välj antal glas';
    if (ship) ship.textContent = total >= FREE_SHIP ? 'Fri frakt på din beställning' : 'Fri frakt över 299 kr';
  }

  app.addEventListener('click', function (e) {
    const step = e.target.closest('[data-step]');
    if (step) {
      const dir = parseInt(step.dataset.dir, 10);
      if (step.dataset.step === 'packs') packs = Math.max(0, Math.min(20, packs + dir));
      else extras = Math.max(0, Math.min(20, extras + dir));
      renderBuy();
    }
    const toggle = e.target.closest('#tt-addon-toggle, #tt-addon-price');
    if (toggle) { extras = extras > 0 ? 0 : 1; renderBuy(); }
  });

  /* --- Lägg i varukorgen ---
     I Shopify: ersätt raden nedan med ett anrop till /cart/add
     (t.ex. fetch('/cart/add.js', {...})) med rätt variant-ID:n. */
  const cta = document.getElementById('tt-addcart');
  if (cta) {
    cta.addEventListener('click', function () {
      const total = packs * PACK_PRICE + extras * GLASS_PRICE;
      if (total <= 0) return;
      cta.classList.add('is-cart-added');
      cta.textContent = '✓ Tillagd i varukorgen';
      setTimeout(renderBuy, 2200);
    });
  }

  renderBuy();
})();